<template>
  <div class="main-page">
    <AboutPage />
    <div class="hairline"></div>

    <TechPage />
    <div class="hairline"></div>

    <ProjectsPage />
    <div class="hairline"></div>

    <CareerPage />
    <div class="hairline"></div>

    <ProfilePage />
    <div class="hairline"></div>

    <ContactPage />
  </div>
</template>

<script>
import AboutPage from "../AboutPage/AboutPage.vue";
import TechPage from "../TechPage/TechPage.vue";
import ProjectsPage from "../ProjectsPage/ProjectsPage.vue";
import CareerPage from "../CareerPage/CareerPage.vue";
import ProfilePage from "../ProfilePage/ProfilePage.vue";
import ContactPage from "../ContactPage/ContactPage.vue";

export default {
  name: "MainPage",

  components: {
    AboutPage,
    TechPage,
    ProjectsPage,
    CareerPage,
    ProfilePage,
    ContactPage,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
